import { ToolbarOptions } from './common/components/RichTextEditor/RichTextEditor';
import { DataSource } from './common/types/common';

export const VENDOR_LIST: any[] = [
  { label: 'ADP', value: 'ADP' },
  { label: 'ActiveCampaign', value: 'ActiveCampaign' },
  { label: 'Adobe Marketo', value: 'Adobe Marketo' },
  { label: 'Anaplan', value: 'Anaplan' },
  { label: 'Asana', value: 'Asana' },
  { label: 'AWS Bedrock', value: 'AWS Bedrock' },
  { label: 'BambooHR', value: 'BambooHR' },
  { label: 'BigCommerce', value: 'BigCommerce' },
  { label: 'Blue Yonder (JDA)', value: 'Blue Yonder (JDA)' },
  { label: 'Board', value: 'Board' },
  { label: 'BMC Remedy', value: 'BMC Remedy' },
  { label: 'Cherwell', value: 'Cherwell' },
  { label: 'Cisco Webex', value: 'Cisco Webex' },
  { label: 'Coupa', value: 'Coupa' },
  { label: 'Eloqua (Oracle)', value: 'Eloqua (Oracle)' },
  { label: 'Epicor', value: 'Epicor' },
  { label: 'Freshservice', value: 'Freshservice' },
  { label: 'GEP SMART', value: 'GEP SMART' },
  { label: 'Google Vertex AI', value: 'Google Vertex AI' },
  { label: 'Google Workspace', value: 'Google Workspace' },
  { label: 'HubSpot', value: 'HubSpot' },
  { label: 'Infor ERP', value: 'Infor ERP' },
  { label: 'Infor SCM', value: 'Infor SCM' },
  { label: 'Ivanti', value: 'Ivanti' },
  { label: 'Jaggaer', value: 'Jaggaer' },
  { label: 'Jira', value: 'Jira' },
  { label: 'Looker', value: 'Looker' },
  { label: 'Magento', value: 'Magento' },
  { label: 'Manhattan Associates', value: 'Manhattan Associates' },
  { label: 'Microsoft 365', value: 'Microsoft 365' },
  { label: 'Microsoft Dynamics', value: 'Microsoft Dynamics' },
  { label: 'Microsoft Dynamics CRM', value: 'Microsoft Dynamics CRM' },
  { label: 'Microsoft Power BI', value: 'Microsoft Power BI' },
  { label: 'Microsoft Project', value: 'Microsoft Project' },
  { label: 'Monday.com', value: 'Monday.com' },
  { label: 'OneStream', value: 'OneStream' },
  { label: 'Oracle CX', value: 'Oracle CX' },
  { label: 'Oracle ERP', value: 'Oracle ERP' },
  { label: 'Oracle HCM', value: 'Oracle HCM' },
  { label: 'Oracle Procurement Cloud', value: 'Oracle Procurement Cloud' },
  { label: 'Oracle SCM', value: 'Oracle SCM' },
  { label: 'OracleEPM', value: 'OracleEPM' },
  { label: 'Pardot (Salesforce)', value: 'Pardot (Salesforce)' },
  { label: 'Qlik', value: 'Qlik' },
  { label: 'Relevance AI', value: 'Relevance AI' },
  { label: 'Salesforce', value: 'Salesforce' },
  { label: 'SAP', value: 'SAP' },
  { label: 'SAP Ariba', value: 'SAP Ariba' },
  { label: 'SAP BusinessObjects', value: 'SAP BusinessObjects' },
  { label: 'SAP Commerce Cloud', value: 'SAP Commerce Cloud' },
  { label: 'SAP SCM', value: 'SAP SCM' },
  { label: 'SAP SuccessFactors', value: 'SAP SuccessFactors' },
  { label: 'ServiceNow', value: 'ServiceNow' },
  { label: 'Shopify', value: 'Shopify' },
  { label: 'Slack', value: 'Slack' },
  { label: 'Smartsheet', value: 'Smartsheet' },
  { label: 'Tableau', value: 'Tableau' },
  { label: 'WooCommerce', value: 'WooCommerce' },
  { label: 'Workday', value: 'Workday' },
  { label: 'ZBrain.ai', value: 'ZBrain.ai' },
  { label: 'Zoho CRM', value: 'Zoho CRM' },
  { label: 'Zoom', value: 'Zoom' },
  { label: 'Other', value: 'Other' },
];

export const DEFAULT_FILE_EXTENSIONS = [
  '.docx',
  '.pdf',
  '.doc',
  '.txt',
  '.md',
  '.jpeg',
  '.jpg',
  '.png',
];
export const aiGenerateMessage =
  'This action will generate new content using AI and replace the existing section data. Do you want to proceed?';

export const saveMessage =
  'There might be some unsaved data. Do you want to save changes before closing the modal?';
export const finalSaveMessage = 'Do you want to save the data?';
export const saveChangesMessage = 'Save Changes';
export const discardChangesMessage = 'Discard Changes';
export const proceedMessage = 'Proceed';

export const approveMessage =
  'Some of the data might be AI-generated. Please review and approve only if it appears accurate.';
export const approveChangesMessage = 'Approve';

export const defaultAcceptChangesMessage = 'Yes';
export const defaultDiscardChangesMessage = 'No';

export const getEstimatesApiFailMsg = 'Something went wrong while getting estimates';
export const graphQlQueryFailMsg = 'Something went wrong while fetching from GraphQL';

export const saveEnterpriseDataMessage =
  'There might be some unsaved data. Do you want to save changes to Enterprise context before closing it?';
export const saveSolutionDraftMessage =
  'Do you want to save the Solution requirements as a draft? All the information will be lost if changes are discarded.';

export const suggestedQuestionsMap: Record<string, string[]> = {
  '/': [
    'How do I start a new industry using the available enterprise context?',
    'What input data do I need to run an effective industry?',
    'What is the Technology Landscape feature in Industry XPLR?',
  ],
  '/process': [
    'What categories and subcategories are available in the Process?',
    'How do I find relevant AI solutions based on a specific function or pain point?',
    'How is the process structured, and how can I explore its different layers?',
  ],
  '/solution-xplr': [
    'How do I capture and validate solution requirements in Solution XPLR?',
    'Can Copilot suggest relevant data sources for my use case?',
    'What is included in the Detailed Opportunity Report and how can I export it?',
  ],
  '/portfolio': [
    'How can I track the progress and status of all my solutions in one view?',
    'How can I view and compare solutions across different domains?',
    'Can you show me solutions ready for implementation?',
  ],
};

export const defaultQuestions = ['How can I get started?', 'Where to find help?'];

export const routeComponentMap = new Map<string, string>([
  ['/', 'Dashboard'],
  ['/industry', 'Industry XPLR'],
  ['/process', 'Process XPLR'],
  ['/ideation-xplr', 'Ideation XPLR'],
  ['/solution-xplr', 'Solution XPLR'],
  ['/portfolio', 'Portfolio XPLR'],
  ['/data-xplr', 'Data XPLR'],
  ['/data-xplr/:id', 'Data XPLR'],
  // ['/design-nexus', 'Functional Design XPLR']
]);

export const copilotFallbackMessage =
  'Hmm... I didn’t catch that. Could you please try rephrasing?';

export const typeOfImpactOptions = [
  { id: 'Transformative', label: 'Transformative' },
  { id: 'Breakthrough', label: 'Breakthrough' },
  { id: 'Incremental', label: 'Incremental' },
];

export const solutionDraftTitle = 'Open Solution';

export const DEFAULT_BUSINESS_OBJECTIVES =
  'Cost Savings: Medium, Revenue Growth: Medium, Customer Experience: Medium, Process Productivity: Medium, Employee Productivity: Medium';
export const DEFAULT_TAXONOMY = 'Software and services / sales and business development';

export const dataSourceKeyLabelMap: Record<string, keyof DataSource> = {
  'Data Source': 'dataSource',
  'Essential/Optional': 'essentialOptional',
  Technology: 'technology',
  Access: 'access',
  Type: 'type',
  'Data Assessment': 'dataAssessment',
  Quality: 'quality',
};

export const additionalIndustryKeywords = [
  'Agriculture',
  'Automotive',
  'Aerospace',
  'Banking',
  'Construction',
  'Consumer Goods',
  'Cybersecurity',
  'Defense',
  'E-Commerce',
  'Education',
  'Energy',
  'Entertainment',
  'Fashion',
  'Finance',
  'FinTech',
  'Food & Beverage',
  'Healthcare',
  'Hospitality',
  'Industrial',
  'Information Technology',
  'Insurance',
  'Legal',
  'Logistics',
  'Manufacturing',
  'Marine',
  'Media',
  'Mining',
  'Oil & Gas',
  'Pharmaceuticals',
  'Public Sector',
  'Real Estate',
  'Renewable Energy',
  'Retail',
  'Robotics',
  'Software',
  'Sports',
  'Supply Chain',
  'Telecommunications',
  'Transportation',
  'Travel',
  'Utilities',
  'Waste Management',
  'Wellness',
  'Biotech',
  'EdTech',
  'MedTech',
  'InsurTech',
  'Other',
];

export const solutionXPLRTooltipText = {
  'Opportunity Statement':
    'Describe the core business problem you want to solve with AI. Focus on inefficiencies, delays, or manual efforts.',
  'Current Process':
    'Briefly outline how the task is handled today — include key steps, tools used, and teams involved.',
  'Proposed Enhancements':
    'Mention the improvements you envision — such as automation, better accuracy, or reduced manual effort.',
  'Estimated Impact':
    'Summarize expected improvements — such as faster processing, reduced errors, or cost savings.',
  'Enterprise Applications':
    'List any major enterprise systems currently used in this process (e.g., SAP, Oracle, Workday).',
  'Other Software':
    'Mention any AI, RPA, or automation tools already used or considered (e.g., UiPath, Power Automate).',
  'Delivery Preferences':
    'State how you’d like to receive the solution — for example, through a chatbot, dashboard, or embedded UI.',
  Timeline:
    'Choose your preferred timeframe for implementing the solution (e.g., 2–4 weeks, 1 quarter).',
  'Upload Document':
    'Attach any relevant notes, screenshots, or files that help explain your use case further.',
};

export const defaultToolbarOptions: ToolbarOptions = {
  fontFamily: true,
  bold: true,
  italic: true,
  underline: true,
  textColor: true,
  highlight: true,
  bulletList: true,
  orderedList: true,
  alignLeft: true,
  alignCenter: true,
  alignRight: true,
  link: true,
  image: true,
  codeBlock: true,
  undo: true,
  redo: true,
  table: true,
};

export const solutionStages = {
  DRAFT: 'DRAFT',
  DATA_SOURCES_DONE: 'DATA_SOURCES_DONE',
  ELABORATED_SUMMARY_IN_PROGRESS: 'ELABORATED_SUMMARY_IN_PROGRESS',
  ELABORATED_SUMMARY_GENERATED: 'ELABORATED_SUMMARY_GENERATED',
  OPPORTUNITY_REPORT_IN_PROGRESS: 'OPPORTUNITY_REPORT_IN_PROGRESS',
  OPPORTUNITY_REPORT_GENERATED: 'OPPORTUNITY_REPORT_GENERATED',
  SUBMITTED: 'SUBMITTED',
};

export const progressStatusMap = {
  DRAFT: 'Draft: Solution Requirements',
  KEY_INFORMATION_DONE: 'Key information',
  DATA_SOURCES_DONE: 'Draft: Data Sources',
  ELABORATED_SUMMARY_IN_PROGRESS: 'Summary In Progress',
  ELABORATED_SUMMARY_GENERATED: 'Summary Generated',
  OPPORTUNITY_REPORT_IN_PROGRESS: 'Report In Progress',
  OPPORTUNITY_REPORT_GENERATED: 'Report Generated',
  SUBMITTED: 'Submitted',
};

export const versionHistoryStatusMap = {
  DRAFT: 'Solution Requirements',
  KEY_INFORMATION_DONE: 'Key information',
  DATA_SOURCES_DONE: 'Data Sources',
  ELABORATED_SUMMARY_GENERATED: 'Summary Generated',
  OPPORTUNITY_REPORT_GENERATED: 'Report Generated',
  SUBMITTED: 'Submitted',
};

export const categoryIdMap = {
  'Security / Governance': '26fa140b-576f-4f02-818a-12380560c44b',
  Infrastructure: '89c20fa8-4839-4961-9682-bae4387e3913',
  'AI Talent': '7d894368-7cd1-498b-9f21-e3624f1ad67e',
};

export const statusColorMap: Record<string, { bgColor: string; color: string; border?: string }> = {
  'Draft: Solution Requirements': {
    bgColor: '#E7E7E7',
    color: '#6E6E6E',
  },
  'Solution Requirements': {
    bgColor: '#E7E7E7',
    color: '#6E6E6E',
  },
  'Draft: Data Sources': {
    bgColor: '#DDE2EB',
    color: '#5C5D68',
  },
  'Data Sources': {
    bgColor: '#DDE2EB',
    color: '#5C5D68',
  },
  'Report In Progress': {
    bgColor: '#E6FFE5',
    color: '#15B535',
  },
  'Report Generated': {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  'Summary In Progress': {
    bgColor: '#FFF8E5',
    color: '#FF972F',
  },
  'Summary Generated': {
    bgColor: '#FFEFEB',
    color: '#FF6E49',
  },
  'Summary - Approved': {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  'Summary - Pending': {
    bgColor: '#FFF8E5',
    color: '#CE6700',
  },
  'Summary - Unapproved': {
    bgColor: '#ff4b4b1c',
    color: '#c44545',
  },
  'Report - Unapproved': {
    bgColor: '#ff4b4b1c',
    color: 'red',
  },
  'Report - Approved': {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  'Report - Pending': {
    bgColor: '#FFF8E5',
    color: '#CE6700',
  },
  'Draft - Unapproved': {
    bgColor: '#ff4b4b1c',
    color: 'red',
  },
  'Draft - Approved': {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  'Draft - Pending': {
    bgColor: '#FFF8E5',
    color: '#CE6700',
  },
  'Sources - Approved': {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  'Sources - Pending': {
    bgColor: '#FFF8E5',
    color: '#CE6700',
  },
  'Sources - Unapproved': {
    bgColor: '#ff4b4b1c',
    color: '#c44545',
  },

  'Source - Pending': {
    bgColor: '#FFF8E5',
    color: '#CE6700',
  },
  'Source - Approved': {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  'Source - Unapproved': {
    bgColor: '#ff4b4b1c',
    color: '#c44545',
  },
  High: {
    bgColor: '#C6ECC9',
    color: '#006F18',
  },
  Medium: {
    bgColor: '#F2ECB2',
    color: '#928D30',
  },
  Low: {
    bgColor: '#ffcdd2',
    color: '#c62828',
  },
};

export const REPORT_PROCESS_DIAGRAM_REPLACABLE_LINK =
  'https://xplr.app.zbrain.ai/my-process-url-placeholder';
